import * as React from 'react';
import './reservationCardList.module.scss';
import { EventReservationIndexView } from '../../../types/eventReservations';
import { ReservationCard } from './ReservationCard';
import { ReservationIndexView } from '../../../types/reservations';

export type AllReservationIndexView = ReservationIndexView | EventReservationIndexView;
type Props = {
  reservations: AllReservationIndexView[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onRequestUpdate: (reservation: AllReservationIndexView) => any;
};

export class ReservationCardList extends React.Component<Props> {
  render() {
    const { reservations, onRequestUpdate } = this.props;
    return (
      <div styleName="card_wrapper">
        <div styleName="reservations">
          {reservations.map((reservation, index) => {
            return (
              <ReservationCard
                key={reservation.id}
                reservation={reservation}
                index={index + 1}
                onRequestUpdate={onRequestUpdate}
              />
            );
          })}
        </div>
      </div>
    );
  }
}
